import React from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {LogoutAction} from "./pages/LogoutAction";
import {User} from "./components/User";
import {LoginPage} from "./pages/LoginPage";
import {ForgotPasswordPage} from "./pages/ForgotPasswordPage";
import {NewPasswordPage} from "./pages/NewPasswordPage";
import {ForgotPasswordMail} from "./pages/ForgotPasswordMail";
import {MainPage} from "./pages/home/MainPage";

export class PublicRouter extends React.Component<any, any> {
    protected user: User = new User();

    render() {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/">
                        <Route index element={<LoginPage/>}/>
                        <Route path="/logout" element={<LogoutAction/>}/>
                        <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>
                        <Route path="/forgot-password-mail" element={<ForgotPasswordMail/>}/>
                        <Route path="/new-password/:id" element={<NewPasswordPage/>}/>

                        <Route path="/stats/all" element={<MainPage/>}/>
                        <Route path="/stats/yearly/:year" element={<MainPage/>}/>
                        <Route path="/stats/daily/:year/:day" element={<MainPage/>}/>
                        <Route path="/stats/weekly/:year/:week" element={<MainPage/>}/>
                        <Route path="/stats/monthly/:year/:month" element={<MainPage/>}/>
                        <Route path="/stats/halfYearly/:year/:halfYear" element={<MainPage/>}/>

                        <Route path="*" element={<LoginPage/>}/>
                    </Route>
                </Routes>
            </BrowserRouter>
        );
    };
}
